import { Suspense, useState } from "react";
import { getMultiplePatientsRdvsStats } from "../../rdvs/filterTransforms/patientRdvsStats";
import {
  PatientMessagesOpenState,
  usePreferences,
  useSelectedPatientIds,
} from "../../main/state/globalState";
import useSelectedPatients from "../hooks/useSelectedPatients";
import { trpc } from "../../main/components/trpc.ts";
import { formaters } from "vincent-utils";
import styles from "./ResumePatient.module.css";
import PatientFlagsChooser from "./PatientFlagsChooser.tsx";
import _ from "underts";
import { CadendarConsts, PatientFlags } from "cadendar-shared";
import Flag from "./Flag.tsx";
import { FaRegFlag } from "react-icons/fa";
import { TiMessages } from "react-icons/ti";
import { skipToken } from "@tanstack/react-query";
import { useSetAtom } from "jotai";
import {Button} from "@/components/ui/button";
import LogosLink from "./LogosLink.tsx";
import { HiArrowLongRight } from "react-icons/hi2";
import { openPatientFile } from "../openPatientFile";

const ResumePatient = () => {
  //const selectedPatients = useSelector(patientsObjectsSelected);
  //const patientsStats = useSelector(getSelectedPatientsRdvStats);
  const [selectedPatientIds] = useSelectedPatientIds();
  const preferences = usePreferences();
  const [showFlagPopup, setShowFlagPopup] = useState(false);
  const [flagPopupTop, setFlagPopupTop] = useState(0);
  const [flagPopupLeft, setFlagPopupLeft] = useState(0);

  const openPatientMessagesPopup = useSetAtom(PatientMessagesOpenState);

  const selectedPatientId = _.first(selectedPatientIds);

  const patientMessages =
    trpc.message.getAllMessagesForPatient.useQuery(
      selectedPatientId ? selectedPatientId : skipToken
    ).data ?? [];

  const patientHasMessages = patientMessages.length > 0;

  const utils = trpc.useContext();
  const patientFlagMutation = trpc.patient.setPatientFlag.useMutation({
    onSuccess: () => {
      utils.patient.invalidate();
      utils.rdv.invalidate();
    },
  });

  const handleFlagReset = () => {
    if (!firstPatient) return;
    patientFlagMutation.mutate({ patientId: firstPatient.id, flag: null });
  };

  const handleFlagClicked = (flag: PatientFlags) => {
    if (!firstPatient) return;
    if (firstPatient.patient_flags === flag) {
      handleFlagReset();
    } else {
      patientFlagMutation.mutate({ patientId: firstPatient.id, flag });
    }
  };

  const handleOpenFlagPopup = (event: React.MouseEvent) => {
    event.stopPropagation();
    const target = event.currentTarget;
    openFlagPopup(
      target.getBoundingClientRect().top,
      target.getBoundingClientRect().right + 10
    );
  };

  const openFlagPopup = (top: number, left: number) => {
    setFlagPopupTop(top);
    setFlagPopupLeft(left);
    setShowFlagPopup(true);
  };

  const handleOpenMessageClick = () => {
    openPatientMessagesPopup(true);
  };

  const handleOpenFileClick = (patientId: string) => {
    openPatientFile({
      patientId,
      allowSingleWindow: preferences?.single_patient_file_window ?? true,
    });
  };

  const selectedPatients = useSelectedPatients();
  console.log("selectedPatients", selectedPatients);
  const { data: selectedPatientsRdvs } = trpc.rdv.findByPatientIds.useQuery(
    _.isNonEmpty(selectedPatientIds)
      ? { patientIds: selectedPatientIds }
      : skipToken
  );

  // const [selectedPatientsRdvs] = useSuperQuery(
  //   ["rdvs", "byPatientsIds", selectedPatientIds],
  //   getPatientsRdvs,
  //   [],
  //   { enabled: selectedPatientIds.length > 0 },
  //   selectedPatientIds
  // );
  const patientsStats = getMultiplePatientsRdvsStats(
    selectedPatientIds,
    selectedPatientsRdvs || []
  );

  const firstPatient = _.first(selectedPatients);
  const flag = firstPatient?.patient_flags;

  document.addEventListener("globalClick", () => {
    setShowFlagPopup(false);
  });

  return (
    <div id="resume_patient">
      {selectedPatients ? (
        selectedPatients.map((patient) => (
          <div key={"resumePatientkey" + patient.id}>
            <div className={`${styles.patientTitle} mb-2.5 flex items-center justify-center gap-[5px] rounded-[5px] bg-[#545454] text-center text-white bg-[#545454] text-white text-center m-[1px]`}>
              <div>
                {patient.name.toUpperCase()}{" "}
                {formaters.capitaliseEveryFirstLetter(patient.forename)}
              </div>
              <div className="flex items-center gap-2">
                <LogosLink
                  fileNumber={patient.logos_file_number}
                  patientId={patient.id}
                />
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  onClick={() => handleOpenFileClick(patient.id)}
                >
                  Dossier
                  <HiArrowLongRight />
                </Button>
              </div>
            </div>
            <div className={styles.buttonSpacer}>
              {!patient.patient_flags ? (
                <Button
                  onClick={handleOpenFlagPopup}
                  title="assigner des flags à ce patient"
                  size="icon"
                  variant="outline"
                >
                  <FaRegFlag />
                </Button>
              ) : (
                <div className={styles.flagSpacer}>
                  <Flag
                    flag={patient.patient_flags}
                    onFlagClicked={handleOpenFlagPopup}
                  />
                </div>
              )}
              <div className="flex gap-2">
                <Button
                  onClick={handleOpenMessageClick}
                  title="Voir les messages associés à ce patient"
                  size="icon"
                  variant="outline"
                >
                  <TiMessages
                    color={patientHasMessages ? "var(--color-blue)" : "auto"}
                  />
                </Button>
              </div>
            </div>

            {patient.patient_flags && patient.patient_flags === "bl" ? (
              <div className={styles.flagSpacer}>
                <Flag
                  flag="bl"
                  label="Ne plus donner de RDV !!"
                  onFlagClicked={handleOpenFlagPopup}
                />
              </div>
            ) : (
              ""
            )}

            <div>
              {patientsStats[patient.id]?.lapinDates.length > 0 ? (
                <div>
                  RDV manqués :{" "}
                  {patientsStats[patient.id].lapinDates.join(", ")}
                </div>
              ) : (
                ""
              )}
              {patientsStats[patient.id]?.manqueRetardDates.length > 0 ? (
                <div>
                  RDV manqués pour cause de retard :{" "}
                  {patientsStats[patient.id]?.manqueRetardDates.join(", ")}
                </div>
              ) : (
                ""
              )}
              {patientsStats[patient.id]?.annTardDates.length > 0 ? (
                <div>
                  Annulations tardives :{" "}
                  {patientsStats[patient.id]?.annTardDates.join(", ")}
                </div>
              ) : (
                ""
              )}
              {patientsStats[patient.id]?.canceledDates.length > 0 ? (
                <div>
                  RDV annulés :{" "}
                  {patientsStats[patient.id]?.canceledDates.join(", ")}
                </div>
              ) : (
                ""
              )}
              {patientsStats[patient.id]?.urgencesDates.length > 0 ? (
                <div>
                  Rdv en urgence :{" "}
                  {patientsStats[patient.id]?.urgencesDates.join(", ")}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ))
      ) : (
        <div className={`bg-[#545454] text-white text-center m-[1px] select-none`}>
          PAS DE PATIENT SELECTIONNE !
        </div>
      )}
      {showFlagPopup ? (
        <div
          style={{ top: flagPopupTop, left: flagPopupLeft }}
          className={styles.popup}
        >
          <PatientFlagsChooser
            onFlagClicked={handleFlagClicked}
            onResetClicked={handleFlagReset}
            patient_flags={flag || null}
            flags={CadendarConsts.patientFlags}
          />
        </div>
      ) : null}
    </div>
  );
};

export default () => (
  <Suspense fallback={<div>Loading...</div>}>
    <ResumePatient />
  </Suspense>
);
